import { render, staticRenderFns } from "./ProjectInternal.vue?vue&type=template&id=c5465342&scoped=true"
import script from "./ProjectInternal.vue?vue&type=script&lang=js"
export * from "./ProjectInternal.vue?vue&type=script&lang=js"
import style0 from "./ProjectInternal.vue?vue&type=style&index=0&id=c5465342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5465342",
  null
  
)

export default component.exports